module.exports = __webpack_public_path__ + "static/media/Stellar Ora King Headboard - 180 cm_Charcoal.0f8cd7f3.png";